import { LayoutType } from 'js/crossword/gameSceneLayouts';
import { ArrowKeysSettings, SpacebarKeySettings, AfterWordActionType } from 'js/crossword/types';
import { Signal } from 'framework/utils/Signal';

export interface ISettingsData {
  solvedThisMonth: number;
  currMonth: number;
  timer: boolean;
  progressBar: boolean;
  layout: LayoutType;
  leftClues: false;
  arrowKeys: ArrowKeysSettings;
  spaceBar: SpacebarKeySettings;
  skipOverFilledSquares: boolean;
  afterWordMoveTo: Record<AfterWordActionType, boolean>;
}

const dataKey = 'crossword-settings-data';

const defaultData: ISettingsData = {
  solvedThisMonth: 0,
  currMonth: -1,
  timer: true,
  progressBar: true,
  leftClues: false,
  arrowKeys: ArrowKeysSettings.Stay,
  spaceBar: SpacebarKeySettings.ClearAndMoveAhead,
  skipOverFilledSquares: true,
  layout: LayoutType.RightOneColumn,
  afterWordMoveTo: {
    [AfterWordActionType.FirstBlankInSameWord]: true,
    [AfterWordActionType.NextClue]: true,
  },
};

let settingsData: ISettingsData = { ...defaultData };

export const onSettingsChanged: Signal<ISettingsData> = new Signal();

export function getDefaultSettings(): Partial<ISettingsData> {
  return defaultData;
}

export function loadSettingsData(): void {
  try {
    const data = localStorage.getItem(dataKey);
    if (data) {
      const parsed: ISettingsData = JSON.parse(data);
      settingsData = handleLoadedSettingsData(parsed);
    }
  } catch (e) {
    console.warn(e);
  }
}

export function saveSettings(): void {
  try {
    localStorage.setItem(dataKey, JSON.stringify(settingsData));
  } catch (e) {
    console.warn(e);
  }
}

export function getSettingsData(): ISettingsData {
  return settingsData;
}

function handleLoadedSettingsData(loadedData: Partial<ISettingsData>): ISettingsData {
  const resultData = { ...defaultData, ...loadedData };
  
  // Check for backwards compatibility
  const { afterWordMoveTo } = loadedData;

  // `afterWordMoveTo` type changed from `AfterWordActionType`(string)
  // to `Record<AfterWordActionType, boolean>` on 09.12.2020
  if (afterWordMoveTo && typeof afterWordMoveTo === "string") {
    resultData.afterWordMoveTo = {
      [AfterWordActionType.FirstBlankInSameWord]: afterWordMoveTo === AfterWordActionType.FirstBlankInSameWord,
      [AfterWordActionType.NextClue]: afterWordMoveTo === AfterWordActionType.NextClue,
    };
  }

  return resultData;
}
